import { render, staticRenderFns } from "./CandidateCourseConfirmed.vue?vue&type=template&id=31c287d9&scoped=true&lang=pug"
import script from "./CandidateCourseConfirmed.vue?vue&type=script&lang=js"
export * from "./CandidateCourseConfirmed.vue?vue&type=script&lang=js"
import style0 from "./CandidateCourseConfirmed.vue?vue&type=style&index=0&id=31c287d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c287d9",
  null
  
)

export default component.exports